import React from 'react';
import { Link } from 'react-router-dom';

export default function FooterPopularSearches({ storeCopy }) {
  const store = storeCopy || {};
  if (store.footer_popular_searches_enabled === false) return null;

  const links = (Array.isArray(store.footer_popular_searches) ? store.footer_popular_searches : []).filter(
    (l) => String(l?.label || '').trim() && String(l?.href || '').trim(),
  );
  if (!links.length) return null;

  const title = store.footer_popular_searches_title || 'Popular searches';

  return (
    <div className="site-footer-searches site-footer-col site-footer-col--searches">
      <h2 className="site-footer-heading">{title}</h2>
      <ul className="site-footer-list site-footer-popular-searches">
        {links.map((link) => {
          const href = String(link.href).trim();
          const isInternal = href.startsWith('/');
          const label = link.label;
          return (
            <li key={`${href}-${label}`}>
              {isInternal ? (
                <Link to={href} className="site-footer-list-link">
                  {label}
                </Link>
              ) : (
                <a href={href} className="site-footer-list-link">
                  {label}
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
